module.exports = __webpack_public_path__ + "static/media/WheatStage103.7e9fb102.PNG";